globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modules = appCustomerSpace.Modules || {};

appCustomerSpace.Modules.InputPhone = (function(){

  InputPhone.selector = '[data-plugin="input-phone"]';

  InputPhone.init = function($html) {
    $html.find(InputPhone.selector).each(function() {
      new InputPhone($(this));
    })
  }

  function InputPhone($html) {
    this.$html        = $html;
    this.$formGroup   = this.$html.parentsUntil(".form-group").parent();
    this.inputName    = this.$html.data("input-name");
    this.options      = this.$html.data("plugin-options") || {};
    this.defaults = {
      initialCountry:     "fr",
      separateDialCode:   true,
      preferredCountries: ["fr"],
      formatOnDisplay:    true,
      hiddenInput:        this.inputName,
      utilsScript:        "intlTelInput/utils.js"
    }

    this.init();
  }

  InputPhone.prototype = {
    init: function() {
      var _this = this;

      _this.$html.intlTelInput($.extend({}, _this.defaults, _this.options, true));
      _this.displayErrors();
      _this.events();
    },
    events: function() {
      var _this = this;

      _this.$html.on("input", function() {
        _this.displayErrors();
      });
    },
    displayErrors: function() {
      var _this = this;

      if(_this.$html.val() == "" || _this.$formGroup.length == 0) { return; }

      if(!_this.$html.intlTelInput("isValidNumber")) {
        _this.$formGroup.addClass("has-error");
      } else {
        _this.$formGroup.removeClass("has-error");
      }
    }
  }

  return InputPhone;

})();
